import { render, staticRenderFns } from "./TotalCompradoPorFilial.vue?vue&type=template&id=c1659498&scoped=true"
import script from "./TotalCompradoPorFilial.vue?vue&type=script&lang=js"
export * from "./TotalCompradoPorFilial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1659498",
  null
  
)

export default component.exports